import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

const API_BASE = "https://mediapi.onlinepharmaque.in/api/v1";

const initialForm = {
  pName: "",
  price: "",
  details: "",
  discountPrice: "",
  offerPrice: "",
  pImg: [],
  subcategoryId: "",
  subcategoryName: "",
  MaincategoryName: "",
  size: [],
  color: [],
  rating: "",
  review: [],
  bottomSize: [],
  shoesSize: [],
  availability: "",
  stock: "",

  // ⭐ NEW OPTIONAL FIELDS
  brand: "",
  model: "",
  manufacturer: "",
};

const ProductModal = ({
  proShowModal,
  shoproShowModal,
  editMode = false,
  editedProduct,
  updateProductData,
}) => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [formData, setFormData] = useState(initialForm);
  const [imgPreview, setImgPreview] = useState([]);

  const [reviewInput, setReviewInput] = useState({
    userName: "",
    rating: "",
    comment: "",
  });

  /* ================= FETCH DATA ================= */

  const fetchCategories = async () => {
    const res = await fetch(`${API_BASE}/getallcategory`);
    const data = await res.json();
    setCategories(data.category || []);
  };

  const fetchSubCategories = async () => {
    const res = await fetch(`${API_BASE}/getsubcategory`);
    const data = await res.json();
    setSubCategories(data.result || []);
  };

  useEffect(() => {
    fetchCategories();
    fetchSubCategories();
  }, []);

  /* ================= EDIT MODE ================= */

  useEffect(() => {
    if (editMode && editedProduct) {
      setFormData({
        ...initialForm,
        pName: editedProduct.pName || "",
        price: editedProduct.price || "",
        details: editedProduct.details || "",
        discountPrice: editedProduct.discountPrice || "",
        offerPrice: editedProduct.offerPrice || "",
        MaincategoryName: editedProduct.MaincategoryName || "",
        subcategoryId: editedProduct.subCategoryId || "",
        rating: editedProduct.rating || "",
        review: editedProduct.review || [],
        stock: editedProduct.stock || "",
        availability: editedProduct.availability || "In Stock",

        // ⭐ NEW FIELDS
        brand: editedProduct.brand || "",
        model: editedProduct.model || "",
        manufacturer: editedProduct.manufacturer || "",
      });
    }
  }, [editMode, editedProduct]);

  /* ================= HANDLERS ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleImageChange = (e) => {
  //     setFormData({ ...formData, pImg: e.target.files });
  // };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    setFormData({ ...formData, pImg: files });

    const previews = files.map((file) => URL.createObjectURL(file));
    setImgPreview(previews);
  };

  const handleSubCategoryChange = (e) => {
    const subcategoryId = e.target.value;

    const selected = subCategories.find((s) => s.id === subcategoryId);

    setFormData((prev) => ({
      ...prev,
      subcategoryId: selected?.id || "",
      subcategoryName: selected?.SubCateoryName || "",
    }));
  };

  /* ================= REVIEW ================= */

  const addReview = () => {
    if (!reviewInput.userName || !reviewInput.rating || !reviewInput.comment) {
      toast.error("Fill all review fields");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      review: [...prev.review, reviewInput],
    }));

    setReviewInput({ userName: "", rating: "", comment: "" });
  };

  const removeReview = (i) => {
    setFormData((prev) => ({
      ...prev,
      review: prev.review.filter((_, index) => index !== i),
    }));
  };

  /* ================= FORM DATA ================= */

  const prepareFormData = () => {
    const fd = new FormData();

    fd.append("pName", formData.pName);
    fd.append("price", formData.price);
    fd.append("details", formData.details);
    fd.append("subcategoryId", formData.subcategoryId);
    fd.append("subcategoryName", formData.subcategoryName);
    fd.append("MaincategoryName", formData.MaincategoryName);
    fd.append("rating", formData.rating);
    fd.append("availability", formData.availability);
    fd.append("stock", formData.stock);

    // ⭐ NEW OPTIONAL FIELDS
    fd.append("brand", formData.brand);
    fd.append("model", formData.model);
    fd.append("manufacturer", formData.manufacturer);

    if (formData.discountPrice) {
      fd.append("discountPrice", formData.discountPrice);
    }

    if (formData.offerPrice) {
      fd.append("offerPrice", formData.offerPrice);
    }

    for (let i = 0; i < formData.pImg.length; i++) {
      fd.append("pImg", formData.pImg[i]);
    }

    fd.append("review", JSON.stringify(formData.review));

    return fd;
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {
    try {
      const url = editMode
        ? `${API_BASE}/updateproduct/${editedProduct._id}`
        : `${API_BASE}/addProduct/${formData.subcategoryId}`;

      const method = editMode ? "patch" : "post";

      const res = await axios[method](url, prepareFormData(), {
        headers: { "Content-Type": "multipart/form-data" },
      });

      updateProductData((prev) =>
        editMode
          ? prev.map((p) =>
              p._id === res.data.result._id ? res.data.result : p,
            )
          : [res.data.result, ...prev],
      );

      toast.success(editMode ? "Product Updated" : "Product Added");
      shoproShowModal(false);
      setFormData(initialForm);
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const removeImage = (index) => {
    const newImg = [...formData.pImg];
    const newPreview = [...imgPreview];

    newImg.splice(index, 1);
    newPreview.splice(index, 1);

    setFormData({ ...formData, pImg: newImg });
    setImgPreview(newPreview);
  };

  if (!proShowModal) return null;

  /* ================= UI ================= */

  return (
    <>
      {/* BACKDROP */}
      <div className="fixed inset-0 bg-black/70 z-40"></div>

      {/* MODAL */}
      <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/60">
  <div className="w-full max-w-5xl bg-[#0f172a] rounded-2xl shadow-2xl border border-gray-700 flex flex-col">

    {/* ================= HEADER ================= */}
    <div className="flex justify-between items-center px-6 py-4 border-b border-gray-700">
      <h2 className="text-xl font-semibold text-white">
        {editMode ? "Edit Product" : "Add Product"}
      </h2>
      <button
        onClick={shoproShowModal}
        className="text-gray-400 hover:text-white text-2xl"
      >
        ✕
      </button>
    </div>

    {/* ================= BODY (SCROLLABLE) ================= */}
    <div className="p-6 max-h-[75vh] overflow-y-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* CATEGORY */}
        <div>
          <label className="text-sm text-gray-400">Category</label>
          <select
            value={formData.MaincategoryName}
            onChange={(e) =>
              setFormData({ ...formData, MaincategoryName: e.target.value })
            }
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          >
            <option value="">Select Category</option>
            {categories.map((c) => (
              <option key={c.id} value={c.MaincategoryName}>
                {c.MaincategoryName}
              </option>
            ))}
          </select>
        </div>

        {/* SUB CATEGORY */}
        <div>
          <label className="text-sm text-gray-400">Sub Category</label>
          <select
            value={formData.subcategoryId}
            onChange={handleSubCategoryChange}
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          >
            <option value="">Select SubCategory</option>
            {subCategories.map((s) => (
              <option key={s.id} value={s.id}>
                {s.SubCateoryName}
              </option>
            ))}
          </select>
        </div>

        {/* PRODUCT NAME */}
        <div>
          <label className="text-sm text-gray-400">Product Name</label>
          <input
            name="pName"
            value={formData.pName}
            onChange={handleChange}
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
            placeholder="Enter product name"
          />
        </div>

        {/* PRICE */}
        <div>
          <label className="text-sm text-gray-400">Price</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
            placeholder="₹ Price"
          />
        </div>

        {/* DISCOUNT */}
        <div>
          <label className="text-sm text-gray-400">Discount Price</label>
          <input
            type="number"
            name="discountPrice"
            value={formData.discountPrice}
            onChange={handleChange}
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
            placeholder="₹ Discount"
          />
        </div>

        {/* IMAGES */}
        <div>
          <label className="text-sm text-gray-400">Product Images</label>
          <input
            type="file"
            multiple
            onChange={handleImageChange}
            className="w-full mt-1 text-sm text-gray-300 bg-[#020617] border border-gray-700 rounded-lg px-3 py-2"
          />
        </div>

        {/* IMAGE PREVIEW */}
        {imgPreview.length > 0 && (
          <div className="md:col-span-2 flex gap-3 flex-wrap">
            {imgPreview.map((src, i) => (
              <div key={i} className="relative">
                <img
                  src={src}
                  alt="preview"
                  className="w-20 h-20 object-cover rounded-lg border border-gray-700"
                />
                <button
                  onClick={() => removeImage(i)}
                  className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full text-xs px-1"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}

        {/* DETAILS */}
        <div className="md:col-span-2">
          <label className="text-sm text-gray-400">Product Details</label>
          <textarea
            rows="3"
            name="details"
            value={formData.details}
            onChange={handleChange}
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
        </div>

        {/* AVAILABILITY */}
        <div>
          <label className="text-sm text-gray-400 mb-2 block">Availability</label>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() =>
                setFormData({ ...formData, availability: "In Stock" })
              }
              className={`flex-1 px-4 py-2 rounded-lg border ${
                formData.availability === "In Stock"
                  ? "bg-green-600 border-green-500 text-white"
                  : "border-gray-700 text-gray-400"
              }`}
            >
              In Stock
            </button>

            <button
              type="button"
              onClick={() =>
                setFormData({ ...formData, availability: "Out of Stock" })
              }
              className={`flex-1 px-4 py-2 rounded-lg border ${
                formData.availability === "Out of Stock"
                  ? "bg-red-600 border-red-500 text-white"
                  : "border-gray-700 text-gray-400"
              }`}
            >
              Out of Stock
            </button>
          </div>
        </div>

        {/* STOCK */}
        <div>
          <label className="text-sm text-gray-400">Stock Quantity</label>
          <input
            type="number"
            min="0"
            name="stock"
            value={formData.stock}
            onChange={(e) =>
              setFormData({
                ...formData,
                stock: e.target.value,
                availability:
                  e.target.value === "0" ? "Out of Stock" : "In Stock",
              })
            }
            className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
        </div>

        {/* BRAND / MODEL / MANUFACTURER */}
        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            placeholder="Brand"
            className="bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <input
            name="model"
            value={formData.model}
            onChange={handleChange}
            placeholder="Model"
            className="bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
          <input
            name="manufacturer"
            value={formData.manufacturer}
            onChange={handleChange}
            placeholder="Manufacturer"
            className="bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
          />
        </div>

      </div>
    </div>

    {/* ================= FOOTER ================= */}
    <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-700">
      <button
        onClick={shoproShowModal}
        className="px-5 py-2 bg-red-500 hover:bg-red-600 rounded-lg text-white"
      >
        Cancel
      </button>
      <button
        onClick={handleSubmit}
        className="px-5 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-white"
      >
        Save
      </button>
    </div>

  </div>
</div>

      
    </>
  );
};

export default ProductModal;
